/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddCrmOpportunityNoteInput,
    AddCrmOpportunityNoteInputFromJSON,
    AddCrmOpportunityNoteInputToJSON,
} from '../models/AddCrmOpportunityNoteInput';
import {
    type AddCrmProjectNoteInput,
    AddCrmProjectNoteInputFromJSON,
    AddCrmProjectNoteInputToJSON,
} from '../models/AddCrmProjectNoteInput';
import {
    type AdminProjectPageData,
    AdminProjectPageDataFromJSON,
    AdminProjectPageDataToJSON,
} from '../models/AdminProjectPageData';
import {
    type CreateCrmOpportunityInput,
    CreateCrmOpportunityInputFromJSON,
    CreateCrmOpportunityInputToJSON,
} from '../models/CreateCrmOpportunityInput';
import {
    type CrmOpportunityDetailData,
    CrmOpportunityDetailDataFromJSON,
    CrmOpportunityDetailDataToJSON,
} from '../models/CrmOpportunityDetailData';
import {
    type CrmProjectDetailData,
    CrmProjectDetailDataFromJSON,
    CrmProjectDetailDataToJSON,
} from '../models/CrmProjectDetailData';
import {
    type CrmProjectEventPageData,
    CrmProjectEventPageDataFromJSON,
    CrmProjectEventPageDataToJSON,
} from '../models/CrmProjectEventPageData';
import {
    type CrmProjectNoteData,
    CrmProjectNoteDataFromJSON,
    CrmProjectNoteDataToJSON,
} from '../models/CrmProjectNoteData';
import {
    type CrmProjectNotePageData,
    CrmProjectNotePageDataFromJSON,
    CrmProjectNotePageDataToJSON,
} from '../models/CrmProjectNotePageData';
import {
    type CrmProjectPageData,
    CrmProjectPageDataFromJSON,
    CrmProjectPageDataToJSON,
} from '../models/CrmProjectPageData';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type SubscriptionAuditAdminPageData,
    SubscriptionAuditAdminPageDataFromJSON,
    SubscriptionAuditAdminPageDataToJSON,
} from '../models/SubscriptionAuditAdminPageData';
import {
    type SubscriptionPackage,
    SubscriptionPackageFromJSON,
    SubscriptionPackageToJSON,
} from '../models/SubscriptionPackage';
import {
    type SubscriptionPackageAdminData,
    SubscriptionPackageAdminDataFromJSON,
    SubscriptionPackageAdminDataToJSON,
} from '../models/SubscriptionPackageAdminData';
import {
    type SubscriptionPackageProjectData,
    SubscriptionPackageProjectDataFromJSON,
    SubscriptionPackageProjectDataToJSON,
} from '../models/SubscriptionPackageProjectData';
import {
    type SubscriptionPackageUpdateData,
    SubscriptionPackageUpdateDataFromJSON,
    SubscriptionPackageUpdateDataToJSON,
} from '../models/SubscriptionPackageUpdateData';
import {
    type SubscriptionPaymentAdminOverviewData,
    SubscriptionPaymentAdminOverviewDataFromJSON,
    SubscriptionPaymentAdminOverviewDataToJSON,
} from '../models/SubscriptionPaymentAdminOverviewData';
import {
    type SubscriptionVatReviewDecisionData,
    SubscriptionVatReviewDecisionDataFromJSON,
    SubscriptionVatReviewDecisionDataToJSON,
} from '../models/SubscriptionVatReviewDecisionData';
import {
    type SubscriptionVatReviewPendingCountData,
    SubscriptionVatReviewPendingCountDataFromJSON,
    SubscriptionVatReviewPendingCountDataToJSON,
} from '../models/SubscriptionVatReviewPendingCountData';
import {
    type UpdateCrmOpportunityInput,
    UpdateCrmOpportunityInputFromJSON,
    UpdateCrmOpportunityInputToJSON,
} from '../models/UpdateCrmOpportunityInput';
import {
    type UpdateCrmProjectInput,
    UpdateCrmProjectInputFromJSON,
    UpdateCrmProjectInputToJSON,
} from '../models/UpdateCrmProjectInput';

export interface AdministrationApiAddCRMOpportunityNoteRequest {
    opportunityId: string;
    addCrmOpportunityNoteInput: AddCrmOpportunityNoteInput;
}

export interface AdministrationApiAddProjectCRMNoteRequest {
    projectId: string;
    addCrmProjectNoteInput: AddCrmProjectNoteInput;
}

export interface AdministrationApiArchiveCRMOpportunityRequest {
    opportunityId: string;
}

export interface AdministrationApiArchiveProjectCRMRequest {
    projectId: string;
}

export interface AdministrationApiCreateAdminSubscriptionPackageRequest {
    subscriptionPackageUpdateData: SubscriptionPackageUpdateData;
}

export interface AdministrationApiCreateCRMOpportunityRequest {
    createCrmOpportunityInput: CreateCrmOpportunityInput;
}

export interface AdministrationApiDeleteAdminSubscriptionPackageRequest {
    packageId: string;
}

export interface AdministrationApiGetCRMOpportunityRequest {
    opportunityId: string;
    notesPage?: number;
    notesPageSize?: GetCRMOpportunityNotesPageSizeEnum;
}

export interface AdministrationApiGetProjectCRMRequest {
    projectId: string;
    notesPage?: number;
    notesPageSize?: GetProjectCRMNotesPageSizeEnum;
}

export interface AdministrationApiListAdminProjectsRequest {
    page?: number;
    pageSize?: ListAdminProjectsPageSizeEnum;
    search?: string | null;
}

export interface AdministrationApiListAdminSubscriptionAuditRequest {
    page?: number;
    pageSize?: ListAdminSubscriptionAuditPageSizeEnum;
    search?: string | null;
    action?: string | null;
    actorType?: string | null;
    actorUserId?: string | null;
    source?: string | null;
    sortBy?: ListAdminSubscriptionAuditSortByEnum;
    sortDirection?: ListAdminSubscriptionAuditSortDirectionEnum;
}

export interface AdministrationApiListCRMOpportunityEventsRequest {
    opportunityId: string;
    page?: number;
    pageSize?: ListCRMOpportunityEventsPageSizeEnum;
}

export interface AdministrationApiListCRMOpportunityNotesRequest {
    opportunityId: string;
    page?: number;
    pageSize?: ListCRMOpportunityNotesPageSizeEnum;
}

export interface AdministrationApiListProjectCRMRequest {
    page?: number;
    pageSize?: ListProjectCRMPageSizeEnum;
    search?: string | null;
    lifecycle?: ListProjectCRMLifecycleEnum;
    crmStatus?: ListProjectCRMCrmStatusEnum;
    integrationType?: string | null;
    integrationScope?: ListProjectCRMIntegrationScopeEnum;
    subscriptionType?: ListProjectCRMSubscriptionTypeEnum;
    category?: ListProjectCRMCategoryEnum;
}

export interface AdministrationApiListProjectCRMEventsRequest {
    projectId: string;
    page?: number;
    pageSize?: ListProjectCRMEventsPageSizeEnum;
}

export interface AdministrationApiResolveAdminSubscriptionVATReviewRequest {
    reviewId: string;
    subscriptionVatReviewDecisionData: SubscriptionVatReviewDecisionData;
}

export interface AdministrationApiUpdateAdminSubscriptionPackageRequest {
    packageId: string;
    subscriptionPackageUpdateData: SubscriptionPackageUpdateData;
}

export interface AdministrationApiUpdateCRMOpportunityRequest {
    opportunityId: string;
    updateCrmOpportunityInput: UpdateCrmOpportunityInput;
}

export interface AdministrationApiUpdateProjectCRMRequest {
    projectId: string;
    updateCrmProjectInput: UpdateCrmProjectInput;
}

/**
 * 
 */
export class AdministrationApi extends runtime.BaseAPI {

    /**
     * Creates request options for addCRMOpportunityNote without sending the request
     */
    async addCRMOpportunityNoteRequestOpts(requestParameters: AdministrationApiAddCRMOpportunityNoteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling addCRMOpportunityNote().'
            );
        }

        if (requestParameters['addCrmOpportunityNoteInput'] == null) {
            throw new runtime.RequiredError(
                'addCrmOpportunityNoteInput',
                'Required parameter "addCrmOpportunityNoteInput" was null or undefined when calling addCRMOpportunityNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}/notes`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCrmOpportunityNoteInputToJSON(requestParameters['addCrmOpportunityNoteInput']),
        };
    }

    /**
     */
    async addCRMOpportunityNoteRaw(requestParameters: AdministrationApiAddCRMOpportunityNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectNoteData>> {
        const requestOptions = await this.addCRMOpportunityNoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectNoteDataFromJSON(jsonValue));
    }

    /**
     */
    async addCRMOpportunityNote(requestParameters: AdministrationApiAddCRMOpportunityNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectNoteData> {
        const response = await this.addCRMOpportunityNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addProjectCRMNote without sending the request
     */
    async addProjectCRMNoteRequestOpts(requestParameters: AdministrationApiAddProjectCRMNoteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling addProjectCRMNote().'
            );
        }

        if (requestParameters['addCrmProjectNoteInput'] == null) {
            throw new runtime.RequiredError(
                'addCrmProjectNoteInput',
                'Required parameter "addCrmProjectNoteInput" was null or undefined when calling addProjectCRMNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/project-crm/{projectId}/notes`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCrmProjectNoteInputToJSON(requestParameters['addCrmProjectNoteInput']),
        };
    }

    /**
     */
    async addProjectCRMNoteRaw(requestParameters: AdministrationApiAddProjectCRMNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectNoteData>> {
        const requestOptions = await this.addProjectCRMNoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectNoteDataFromJSON(jsonValue));
    }

    /**
     */
    async addProjectCRMNote(requestParameters: AdministrationApiAddProjectCRMNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectNoteData> {
        const response = await this.addProjectCRMNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for archiveCRMOpportunity without sending the request
     */
    async archiveCRMOpportunityRequestOpts(requestParameters: AdministrationApiArchiveCRMOpportunityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling archiveCRMOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}/archive`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async archiveCRMOpportunityRaw(requestParameters: AdministrationApiArchiveCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmOpportunityDetailData>> {
        const requestOptions = await this.archiveCRMOpportunityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmOpportunityDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async archiveCRMOpportunity(requestParameters: AdministrationApiArchiveCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmOpportunityDetailData> {
        const response = await this.archiveCRMOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for archiveProjectCRM without sending the request
     */
    async archiveProjectCRMRequestOpts(requestParameters: AdministrationApiArchiveProjectCRMRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling archiveProjectCRM().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/project-crm/{projectId}/archive`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async archiveProjectCRMRaw(requestParameters: AdministrationApiArchiveProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectDetailData>> {
        const requestOptions = await this.archiveProjectCRMRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async archiveProjectCRM(requestParameters: AdministrationApiArchiveProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectDetailData> {
        const response = await this.archiveProjectCRMRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createAdminSubscriptionPackage without sending the request
     */
    async createAdminSubscriptionPackageRequestOpts(requestParameters: AdministrationApiCreateAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['subscriptionPackageUpdateData'] == null) {
            throw new runtime.RequiredError(
                'subscriptionPackageUpdateData',
                'Required parameter "subscriptionPackageUpdateData" was null or undefined when calling createAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/subscription-packages`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionPackageUpdateDataToJSON(requestParameters['subscriptionPackageUpdateData']),
        };
    }

    /**
     */
    async createAdminSubscriptionPackageRaw(requestParameters: AdministrationApiCreateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPackage>> {
        const requestOptions = await this.createAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPackageFromJSON(jsonValue));
    }

    /**
     */
    async createAdminSubscriptionPackage(requestParameters: AdministrationApiCreateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPackage> {
        const response = await this.createAdminSubscriptionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCRMOpportunity without sending the request
     */
    async createCRMOpportunityRequestOpts(requestParameters: AdministrationApiCreateCRMOpportunityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createCrmOpportunityInput'] == null) {
            throw new runtime.RequiredError(
                'createCrmOpportunityInput',
                'Required parameter "createCrmOpportunityInput" was null or undefined when calling createCRMOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/crm-opportunities`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCrmOpportunityInputToJSON(requestParameters['createCrmOpportunityInput']),
        };
    }

    /**
     */
    async createCRMOpportunityRaw(requestParameters: AdministrationApiCreateCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmOpportunityDetailData>> {
        const requestOptions = await this.createCRMOpportunityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmOpportunityDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async createCRMOpportunity(requestParameters: AdministrationApiCreateCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmOpportunityDetailData> {
        const response = await this.createCRMOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAdminSubscriptionPackage without sending the request
     */
    async deleteAdminSubscriptionPackageRequestOpts(requestParameters: AdministrationApiDeleteAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling deleteAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-packages/{packageId}`;
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteAdminSubscriptionPackageRaw(requestParameters: AdministrationApiDeleteAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAdminSubscriptionPackage(requestParameters: AdministrationApiDeleteAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdminSubscriptionPackageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAdminPendingSubscriptionVATReviewCount without sending the request
     */
    async getAdminPendingSubscriptionVATReviewCountRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-payments/pending-vat-review-count`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAdminPendingSubscriptionVATReviewCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionVatReviewPendingCountData>> {
        const requestOptions = await this.getAdminPendingSubscriptionVATReviewCountRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionVatReviewPendingCountDataFromJSON(jsonValue));
    }

    /**
     */
    async getAdminPendingSubscriptionVATReviewCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionVatReviewPendingCountData> {
        const response = await this.getAdminPendingSubscriptionVATReviewCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCRMOpportunity without sending the request
     */
    async getCRMOpportunityRequestOpts(requestParameters: AdministrationApiGetCRMOpportunityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling getCRMOpportunity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['notesPage'] != null) {
            queryParameters['notesPage'] = requestParameters['notesPage'];
        }

        if (requestParameters['notesPageSize'] != null) {
            queryParameters['notesPageSize'] = requestParameters['notesPageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCRMOpportunityRaw(requestParameters: AdministrationApiGetCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmOpportunityDetailData>> {
        const requestOptions = await this.getCRMOpportunityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmOpportunityDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async getCRMOpportunity(requestParameters: AdministrationApiGetCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmOpportunityDetailData> {
        const response = await this.getCRMOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectCRM without sending the request
     */
    async getProjectCRMRequestOpts(requestParameters: AdministrationApiGetProjectCRMRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectCRM().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['notesPage'] != null) {
            queryParameters['notesPage'] = requestParameters['notesPage'];
        }

        if (requestParameters['notesPageSize'] != null) {
            queryParameters['notesPageSize'] = requestParameters['notesPageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/project-crm/{projectId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProjectCRMRaw(requestParameters: AdministrationApiGetProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectDetailData>> {
        const requestOptions = await this.getProjectCRMRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async getProjectCRM(requestParameters: AdministrationApiGetProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectDetailData> {
        const response = await this.getProjectCRMRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAdminProjects without sending the request
     */
    async listAdminProjectsRequestOpts(requestParameters: AdministrationApiListAdminProjectsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/projects`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminProjectsRaw(requestParameters: AdministrationApiListAdminProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProjectPageData>> {
        const requestOptions = await this.listAdminProjectsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProjectPageDataFromJSON(jsonValue));
    }

    /**
     */
    async listAdminProjects(requestParameters: AdministrationApiListAdminProjectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProjectPageData> {
        const response = await this.listAdminProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAdminSubscriptionAudit without sending the request
     */
    async listAdminSubscriptionAuditRequestOpts(requestParameters: AdministrationApiListAdminSubscriptionAuditRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        if (requestParameters['actorType'] != null) {
            queryParameters['actorType'] = requestParameters['actorType'];
        }

        if (requestParameters['actorUserId'] != null) {
            queryParameters['actorUserId'] = requestParameters['actorUserId'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-audit`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminSubscriptionAuditRaw(requestParameters: AdministrationApiListAdminSubscriptionAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionAuditAdminPageData>> {
        const requestOptions = await this.listAdminSubscriptionAuditRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionAuditAdminPageDataFromJSON(jsonValue));
    }

    /**
     */
    async listAdminSubscriptionAudit(requestParameters: AdministrationApiListAdminSubscriptionAuditRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionAuditAdminPageData> {
        const response = await this.listAdminSubscriptionAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAdminSubscriptionPackages without sending the request
     */
    async listAdminSubscriptionPackagesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-packages`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminSubscriptionPackagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackageAdminData>>> {
        const requestOptions = await this.listAdminSubscriptionPackagesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageAdminDataFromJSON));
    }

    /**
     */
    async listAdminSubscriptionPackages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackageAdminData>> {
        const response = await this.listAdminSubscriptionPackagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAdminSubscriptionPayments without sending the request
     */
    async listAdminSubscriptionPaymentsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-payments`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listAdminSubscriptionPaymentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPaymentAdminOverviewData>> {
        const requestOptions = await this.listAdminSubscriptionPaymentsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPaymentAdminOverviewDataFromJSON(jsonValue));
    }

    /**
     */
    async listAdminSubscriptionPayments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPaymentAdminOverviewData> {
        const response = await this.listAdminSubscriptionPaymentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCRMOpportunityEvents without sending the request
     */
    async listCRMOpportunityEventsRequestOpts(requestParameters: AdministrationApiListCRMOpportunityEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling listCRMOpportunityEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}/events`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listCRMOpportunityEventsRaw(requestParameters: AdministrationApiListCRMOpportunityEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectEventPageData>> {
        const requestOptions = await this.listCRMOpportunityEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectEventPageDataFromJSON(jsonValue));
    }

    /**
     */
    async listCRMOpportunityEvents(requestParameters: AdministrationApiListCRMOpportunityEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectEventPageData> {
        const response = await this.listCRMOpportunityEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCRMOpportunityNotes without sending the request
     */
    async listCRMOpportunityNotesRequestOpts(requestParameters: AdministrationApiListCRMOpportunityNotesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling listCRMOpportunityNotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}/notes`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listCRMOpportunityNotesRaw(requestParameters: AdministrationApiListCRMOpportunityNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectNotePageData>> {
        const requestOptions = await this.listCRMOpportunityNotesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectNotePageDataFromJSON(jsonValue));
    }

    /**
     */
    async listCRMOpportunityNotes(requestParameters: AdministrationApiListCRMOpportunityNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectNotePageData> {
        const response = await this.listCRMOpportunityNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectCRM without sending the request
     */
    async listProjectCRMRequestOpts(requestParameters: AdministrationApiListProjectCRMRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['lifecycle'] != null) {
            queryParameters['lifecycle'] = requestParameters['lifecycle'];
        }

        if (requestParameters['crmStatus'] != null) {
            queryParameters['crmStatus'] = requestParameters['crmStatus'];
        }

        if (requestParameters['integrationType'] != null) {
            queryParameters['integrationType'] = requestParameters['integrationType'];
        }

        if (requestParameters['integrationScope'] != null) {
            queryParameters['integrationScope'] = requestParameters['integrationScope'];
        }

        if (requestParameters['subscriptionType'] != null) {
            queryParameters['subscriptionType'] = requestParameters['subscriptionType'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/project-crm`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listProjectCRMRaw(requestParameters: AdministrationApiListProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectPageData>> {
        const requestOptions = await this.listProjectCRMRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectPageDataFromJSON(jsonValue));
    }

    /**
     */
    async listProjectCRM(requestParameters: AdministrationApiListProjectCRMRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectPageData> {
        const response = await this.listProjectCRMRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectCRMEvents without sending the request
     */
    async listProjectCRMEventsRequestOpts(requestParameters: AdministrationApiListProjectCRMEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectCRMEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/project-crm/{projectId}/events`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listProjectCRMEventsRaw(requestParameters: AdministrationApiListProjectCRMEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectEventPageData>> {
        const requestOptions = await this.listProjectCRMEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectEventPageDataFromJSON(jsonValue));
    }

    /**
     */
    async listProjectCRMEvents(requestParameters: AdministrationApiListProjectCRMEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectEventPageData> {
        const response = await this.listProjectCRMEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSubscriptionPackageProjects without sending the request
     */
    async listSubscriptionPackageProjectsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/admin/subscription-package-projects`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listSubscriptionPackageProjectsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackageProjectData>>> {
        const requestOptions = await this.listSubscriptionPackageProjectsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageProjectDataFromJSON));
    }

    /**
     */
    async listSubscriptionPackageProjects(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackageProjectData>> {
        const response = await this.listSubscriptionPackageProjectsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resolveAdminSubscriptionVATReview without sending the request
     */
    async resolveAdminSubscriptionVATReviewRequestOpts(requestParameters: AdministrationApiResolveAdminSubscriptionVATReviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['reviewId'] == null) {
            throw new runtime.RequiredError(
                'reviewId',
                'Required parameter "reviewId" was null or undefined when calling resolveAdminSubscriptionVATReview().'
            );
        }

        if (requestParameters['subscriptionVatReviewDecisionData'] == null) {
            throw new runtime.RequiredError(
                'subscriptionVatReviewDecisionData',
                'Required parameter "subscriptionVatReviewDecisionData" was null or undefined when calling resolveAdminSubscriptionVATReview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/subscription-vat-reviews/{reviewId}/decision`;
        urlPath = urlPath.replace('{reviewId}', encodeURIComponent(String(requestParameters['reviewId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionVatReviewDecisionDataToJSON(requestParameters['subscriptionVatReviewDecisionData']),
        };
    }

    /**
     */
    async resolveAdminSubscriptionVATReviewRaw(requestParameters: AdministrationApiResolveAdminSubscriptionVATReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resolveAdminSubscriptionVATReviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resolveAdminSubscriptionVATReview(requestParameters: AdministrationApiResolveAdminSubscriptionVATReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resolveAdminSubscriptionVATReviewRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateAdminSubscriptionPackage without sending the request
     */
    async updateAdminSubscriptionPackageRequestOpts(requestParameters: AdministrationApiUpdateAdminSubscriptionPackageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling updateAdminSubscriptionPackage().'
            );
        }

        if (requestParameters['subscriptionPackageUpdateData'] == null) {
            throw new runtime.RequiredError(
                'subscriptionPackageUpdateData',
                'Required parameter "subscriptionPackageUpdateData" was null or undefined when calling updateAdminSubscriptionPackage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/subscription-packages/{packageId}`;
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionPackageUpdateDataToJSON(requestParameters['subscriptionPackageUpdateData']),
        };
    }

    /**
     */
    async updateAdminSubscriptionPackageRaw(requestParameters: AdministrationApiUpdateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPackage>> {
        const requestOptions = await this.updateAdminSubscriptionPackageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPackageFromJSON(jsonValue));
    }

    /**
     */
    async updateAdminSubscriptionPackage(requestParameters: AdministrationApiUpdateAdminSubscriptionPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPackage> {
        const response = await this.updateAdminSubscriptionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCRMOpportunity without sending the request
     */
    async updateCRMOpportunityRequestOpts(requestParameters: AdministrationApiUpdateCRMOpportunityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling updateCRMOpportunity().'
            );
        }

        if (requestParameters['updateCrmOpportunityInput'] == null) {
            throw new runtime.RequiredError(
                'updateCrmOpportunityInput',
                'Required parameter "updateCrmOpportunityInput" was null or undefined when calling updateCRMOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/crm-opportunities/{opportunityId}`;
        urlPath = urlPath.replace('{opportunityId}', encodeURIComponent(String(requestParameters['opportunityId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCrmOpportunityInputToJSON(requestParameters['updateCrmOpportunityInput']),
        };
    }

    /**
     */
    async updateCRMOpportunityRaw(requestParameters: AdministrationApiUpdateCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmOpportunityDetailData>> {
        const requestOptions = await this.updateCRMOpportunityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmOpportunityDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async updateCRMOpportunity(requestParameters: AdministrationApiUpdateCRMOpportunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmOpportunityDetailData> {
        const response = await this.updateCRMOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectCRM without sending the request
     */
    async updateProjectCRMRequestOpts(requestParameters: AdministrationApiUpdateProjectCRMRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectCRM().'
            );
        }

        if (requestParameters['updateCrmProjectInput'] == null) {
            throw new runtime.RequiredError(
                'updateCrmProjectInput',
                'Required parameter "updateCrmProjectInput" was null or undefined when calling updateProjectCRM().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/admin/project-crm/{projectId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCrmProjectInputToJSON(requestParameters['updateCrmProjectInput']),
        };
    }

    /**
     */
    async updateProjectCRMRaw(requestParameters: AdministrationApiUpdateProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmProjectDetailData>> {
        const requestOptions = await this.updateProjectCRMRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmProjectDetailDataFromJSON(jsonValue));
    }

    /**
     */
    async updateProjectCRM(requestParameters: AdministrationApiUpdateProjectCRMRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmProjectDetailData> {
        const response = await this.updateProjectCRMRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCRMOpportunityNotesPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetCRMOpportunityNotesPageSizeEnum = typeof GetCRMOpportunityNotesPageSizeEnum[keyof typeof GetCRMOpportunityNotesPageSizeEnum];
/**
 * @export
 */
export const GetProjectCRMNotesPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetProjectCRMNotesPageSizeEnum = typeof GetProjectCRMNotesPageSizeEnum[keyof typeof GetProjectCRMNotesPageSizeEnum];
/**
 * @export
 */
export const ListAdminProjectsPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListAdminProjectsPageSizeEnum = typeof ListAdminProjectsPageSizeEnum[keyof typeof ListAdminProjectsPageSizeEnum];
/**
 * @export
 */
export const ListAdminSubscriptionAuditPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListAdminSubscriptionAuditPageSizeEnum = typeof ListAdminSubscriptionAuditPageSizeEnum[keyof typeof ListAdminSubscriptionAuditPageSizeEnum];
/**
 * @export
 */
export const ListAdminSubscriptionAuditSortByEnum = {
    OccurredAt: 'occurredAt',
    Project: 'project',
    Action: 'action',
    Actor: 'actor',
    CurrentPackage: 'currentPackage',
    NewPackage: 'newPackage',
    EffectiveAt: 'effectiveAt'
} as const;
export type ListAdminSubscriptionAuditSortByEnum = typeof ListAdminSubscriptionAuditSortByEnum[keyof typeof ListAdminSubscriptionAuditSortByEnum];
/**
 * @export
 */
export const ListAdminSubscriptionAuditSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListAdminSubscriptionAuditSortDirectionEnum = typeof ListAdminSubscriptionAuditSortDirectionEnum[keyof typeof ListAdminSubscriptionAuditSortDirectionEnum];
/**
 * @export
 */
export const ListCRMOpportunityEventsPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListCRMOpportunityEventsPageSizeEnum = typeof ListCRMOpportunityEventsPageSizeEnum[keyof typeof ListCRMOpportunityEventsPageSizeEnum];
/**
 * @export
 */
export const ListCRMOpportunityNotesPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListCRMOpportunityNotesPageSizeEnum = typeof ListCRMOpportunityNotesPageSizeEnum[keyof typeof ListCRMOpportunityNotesPageSizeEnum];
/**
 * @export
 */
export const ListProjectCRMPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListProjectCRMPageSizeEnum = typeof ListProjectCRMPageSizeEnum[keyof typeof ListProjectCRMPageSizeEnum];
/**
 * @export
 */
export const ListProjectCRMLifecycleEnum = {
    Active: 'active',
    Deleted: 'deleted',
    All: 'all'
} as const;
export type ListProjectCRMLifecycleEnum = typeof ListProjectCRMLifecycleEnum[keyof typeof ListProjectCRMLifecycleEnum];
/**
 * @export
 */
export const ListProjectCRMCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type ListProjectCRMCrmStatusEnum = typeof ListProjectCRMCrmStatusEnum[keyof typeof ListProjectCRMCrmStatusEnum];
/**
 * @export
 */
export const ListProjectCRMIntegrationScopeEnum = {
    Current: 'current',
    Ever: 'ever',
    Active: 'active',
    Paused: 'paused',
    Inactive: 'inactive',
    Removed: 'removed',
    Unknown: 'unknown'
} as const;
export type ListProjectCRMIntegrationScopeEnum = typeof ListProjectCRMIntegrationScopeEnum[keyof typeof ListProjectCRMIntegrationScopeEnum];
/**
 * @export
 */
export const ListProjectCRMSubscriptionTypeEnum = {
    All: 'all',
    Trial: 'trial',
    Paid: 'paid',
    Free: 'free',
    None: 'none',
    Unknown: 'unknown'
} as const;
export type ListProjectCRMSubscriptionTypeEnum = typeof ListProjectCRMSubscriptionTypeEnum[keyof typeof ListProjectCRMSubscriptionTypeEnum];
/**
 * @export
 */
export const ListProjectCRMCategoryEnum = {
    All: 'all',
    Active: 'active',
    Inactive: 'inactive',
    Opportunity: 'opportunity',
    Deleted: 'deleted'
} as const;
export type ListProjectCRMCategoryEnum = typeof ListProjectCRMCategoryEnum[keyof typeof ListProjectCRMCategoryEnum];
/**
 * @export
 */
export const ListProjectCRMEventsPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type ListProjectCRMEventsPageSizeEnum = typeof ListProjectCRMEventsPageSizeEnum[keyof typeof ListProjectCRMEventsPageSizeEnum];
